import Signup from './pages/signup';

export default Signup;
